import MessageMedical from "assets/menu-icons/MessageMedical";

const chatFeedBack = {
  id: 'chatFeedBack',
  type: 'group',
  children: [{
    id: 'chatFeedBack',
    title: 'Обратная связь', 
    type: 'item',
    url: '/chatFeedBack',
    icon: MessageMedical,
    breadcrumbs: false
  }]
}

export default chatFeedBack;
